/**
 * Raise AVPlay buffering for UDP multicast (Hotel TV).
 * Must be called in IDLE after open(), before prepare()/prepareAsync().
 *
 * Defaults are higher than Samsung's typical ~10s so short UDP jitter
 * is absorbed instead of showing as lag/macroblocks.
 */
const PLAY_BUFFER_SECONDS = 10;
const RESUME_BUFFER_SECONDS = 15;

export function applyAvplayBuffering(avplayObj, logPrefix = 'AVPlay') {
  if (!avplayObj || typeof avplayObj.setBufferingParam !== 'function') {
    console.warn(logPrefix + ': setBufferingParam not available — skip');
    return false;
  }

  try {
    avplayObj.setBufferingParam(
      'PLAYER_BUFFER_FOR_PLAY',
      'PLAYER_BUFFER_SIZE_IN_SECOND',
      PLAY_BUFFER_SECONDS
    );
    avplayObj.setBufferingParam(
      'PLAYER_BUFFER_FOR_RESUME',
      'PLAYER_BUFFER_SIZE_IN_SECOND',
      RESUME_BUFFER_SECONDS
    );
    console.log(
      logPrefix +
        ': buffering set play=' +
        PLAY_BUFFER_SECONDS +
        's resume=' +
        RESUME_BUFFER_SECONDS +
        's'
    );
    return true;
  } catch (err) {
    console.warn(
      logPrefix + ': setBufferingParam failed:',
      err && (err.name || err.message)
    );
    return false;
  }
}
